export enum DocumentConnectorCodeEnum {
	CHAINTRUST = 'chaintrust',
	AGIRIS_AXE = 'agiris-axe',
	AGIRIS_FIDORG = 'agiris-fidorg',
	SFTP = 'sftp',
	ACD = 'acd',
	YOOZ = 'yooz',
	DOCUWARE = 'docuware',
}
